import { render, staticRenderFns } from "./BrandPointEditor.vue?vue&type=template&id=416f9801&scoped=true&"
import script from "./BrandPointEditor.vue?vue&type=script&lang=ts&"
export * from "./BrandPointEditor.vue?vue&type=script&lang=ts&"
import style0 from "./BrandPointEditor.vue?vue&type=style&index=0&id=416f9801&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "416f9801",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VForm } from 'vuetify/lib/components/VForm';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VCol,VForm,VRow,VTextField})
